import Cookies from 'js-cookie'

export function getLocale() {
  return Cookies.get('locale') || 'ko-KR'
}

export function setLocale(locale) {
  Cookies.set('locale', locale)
}
